import React from 'react';
import groupBy from 'lodash/groupBy';
import trimStart from 'lodash/trimStart';
import DisplayGroup from './display-group';
import makeCancelable from '../../../utils/makeCancelable';



let request = obj => {
  return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest();
      xhr.open(obj.method || "GET", obj.url);
      if (obj.headers) {
          Object.keys(obj.headers).forEach(key => {
              xhr.setRequestHeader(key, obj.headers[key]);
          });
      }
      xhr.onload = () => {
          if (xhr.status >= 200 && xhr.status < 300) {
              resolve(xhr.response);
          } else {
              reject(xhr.statusText);
          }
      };
      xhr.onerror = () => reject(xhr.statusText);
      xhr.send(obj.body);
  });
};


class DisplayLibrary extends React.Component {
  constructor(props){
    super(props);
    
    this.state = {
      content: null,
    }
    this.renderDownloadLinks = this.renderDownloadLinks.bind(this);
    this.renderAttributes = this.renderAttributes.bind(this);
  }
  componentDidMount() {
    return this.renderDownloadLinks();    
  }
  componentWillUnmount() {
    if(this.cancelablePromise) {
      this.cancelablePromise.cancel();
    }    
  }
  renderResponse(resultCEDALS) {
    const out=[];
    const mmcDownloads=[];
    let content;
    if(resultCEDALS && resultCEDALS.response && resultCEDALS.response.docs) {
        
      for(let j=0; j<resultCEDALS.response.docs.length; j++) {
        const currRes = resultCEDALS.response.docs[j];
        const obj={};
        obj.title = currRes.doctitle[0];
        obj.path = currRes.dpath;
        obj.type = currRes.doctype;
        obj.fileName = currRes.resourcename;
        mmcDownloads.push(obj);
      }
    }
    
    const titleGroup = groupBy(mmcDownloads, 'title');
    const titleKeys = Object.keys(titleGroup);
    if(titleKeys.length >0) {
      for(let i=0; i<titleKeys.length; i++) {
        const currArr = titleGroup[titleKeys[i]];
        const keyArr = [];
        for(let j=0; j<currArr.length; j++) {
          const base64data = btoa(currArr[j].path);
          keyArr.push({ title: `${currArr[j].fileName}`, source: `http://coe-wpcpwp04dcp.eis.ds.usace.army.mil:8090/search_api/getfile?item=${encodeURIComponent(base64data)}` }); 
        }
        out.push({downloadGroup:trimStart(titleKeys[i].split('-')[1]), links:keyArr});
      }
    }
      if(out && out.length >0) {
        content =(
          <>
            <h5><u>Available Products</u></h5>
            <div style={{display:'flex', flexDirection:'column', marginLeft:'18px'}}>
              {out.map((val, idx)=>{
                return(
                  <div key={`${val.downloadGroup}-${idx}`}>
                    <h6 style={{marginTop:'6px', marginBottom:'6px'}}><u>{val.downloadGroup}</u></h6>
                    <div style={{display:'flex', flexDirection:'column', marginLeft:'12px'}}>
                      {val.links.map((intVal, inIdx)=> {
                        return(
                          <a key={`${intVal.title}-${inIdx}`} href={intVal.source}>{intVal.title}</a>
                        )
                      })}
                    </div>
                  </div>
                )
              })}
              
            </div>
          </>
        )
      }else{
        content =(
        <>
            <h5><u>Available Products</u></h5>
            <h6>No Products Available</h6>
          </>
        )
      }
        
      
    
    this.setState({content: content})
  }
  renderDownloadLinks(){
    const {data} = this.props;
    const {mmcIds} = data;
    let content = (
      <>
      <h5><u>Available Products</u></h5>
      <h6>Fetching Products..</h6>
      </>    
    )
    if(mmcIds && mmcIds.length >0) {
      content = (
        <>
        <h5><u>Available Products</u></h5>
        <h6>Fetching Products..</h6>
        </>    
      )
      const url = `https://geo1.mmc.usace.army.mil/solr74/cedals/select?fl=id,resourcename,doctype,doctitle,dpath&fq=doctype:Report&fq=mmcid:${ mmcIds }&indent=on&q=*:*&wt=json`;
      
      this.cancelablePromise = makeCancelable(
        request({url:url})
      );
      this.cancelablePromise
        .then((results) => {
          const jsonData = JSON.parse(results);
          this.renderResponse(jsonData);
        })
        .catch(function (e) {
          console.error('XHR error', e);
        });
      
     }else if(mmcIds && mmcIds.length === 0){
      content = (
        <>
        <h5><u>Available Products</u></h5>
        <h6>No MMC Projects Linked to this Library</h6>
        </>
       )
     }else(
      content = (
        <>
        <h5><u>Available Products</u></h5>
        <h6>No Products Available</h6>
        </>
       )
     ) 
    
   
    
    this.setState({content: content});
  }
  renderAttributes(){
    const {data} = this.props;
    const {display} = data;
    let content =[];
    if(display && display.length>0) {
      content = display.map((obj, idx) => {
        return(<DisplayGroup key={`${obj.title}-${idx}`} title={obj.title} children={obj.children} subGroup={obj.subGroup}/>)
        ;
      })
    }
    return content
  }
  render(){
    const {content} = this.state;
    return (
      <div>
        {this.renderAttributes()}
        {content}  
      </div>
    )
  }
}

export default DisplayLibrary;
